import { render, staticRenderFns } from "./MenuControls.vue?vue&type=template&id=7282ca75&scoped=true"
import script from "./MenuControls.vue?vue&type=script&lang=js"
export * from "./MenuControls.vue?vue&type=script&lang=js"
import style0 from "./MenuControls.vue?vue&type=style&index=0&id=7282ca75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7282ca75",
  null
  
)

export default component.exports